import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";

import { LayoutComponent } from "./layouts/layout/layout.component";
const routes: Routes = [
  // {
  //   path: "superUsersdashboard",
  //   loadChildren: () =>
  //     import("./superUsers/superUsers.module").then((m) => m.SuperUsersModule),
  //   canActivate: [AuthGuard, RoleGuard],
  //   data: { roles: ["SUPERADMIN"] },
  // },
  {
    path: "account",
    loadChildren: () =>
      import("./account/account.module").then((m) => m.AccountModule),
  },
  // tslint:disable-next-line: max-line-length
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./adminPage/adminpages.module").then((m) => m.adminPagesModule),
    // canActivate: [AuthGuard],
  },

  // { path: '**', redirectTo: '/account' }

  // {
  //   path: "admin",
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("./admin_page/admin_pages.module").then((m) => m.AdminPagesModule),
  //   canActivate: [AuthGuard],
  // },

  // {
  //   path: "admin",
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("./admin_page/admin_pages.module").then((m) => m.AdminPagesModule),
  //   canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
